import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "icon-rotate" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "text-primary icon-rotate" }

import {
  reactive,
} from 'vue';
import Expansion from '@/components/Expansion.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons';


export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
    required: true,
  },
  expanded: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  type: {
    type: String,
    required: false,
    default: () => 'default',
  },
},
  setup(__props) {

const props = __props

library.add(faChevronDown);



const component = reactive({
  expanded: props.expanded,
});

const toggle = () => {
  component.expanded = !component.expanded;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["expand", { 'expanded': _unref(component).expanded }])
  }, [
    _createElementVNode("button", {
      onClick: toggle,
      class: _normalizeClass(__props.type)
    }, [
      (__props.type === 'default')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("span", _hoisted_1, [
              _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-chevron-down" })
            ]),
            _createElementVNode("span", { innerHTML: __props.title }, null, 8, _hoisted_2),
            _hoisted_3
          ], 64))
        : _createCommentVNode("", true),
      (__props.type === 'small')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("span", {
              class: "text-primary",
              innerHTML: __props.title
            }, null, 8, _hoisted_4),
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_unref(FontAwesomeIcon), { icon: "fa-light fa-chevron-down" })
            ])
          ], 64))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(Expansion, {
      expanded: _unref(component).expanded
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _: 3
    }, 8, ["expanded"])
  ], 2))
}
}

})